export class RaisonAnnulation {
  id: number;
  raison: string;
  constructor(id: number, raison: string) {
    this.id = id;
    this.raison = raison;
  }
}
